$("#carousel-game").carousel();

$("#carousel-game .next").click(function (e) {
  e.preventDefault();
  e.stopPropagation();
  $("#carousel-game").carousel("next");
});

$("#carousel-game .prev").click(function (e) {
  e.preventDefault();
  e.stopPropagation();
  $("#carousel-game").carousel("prev");
});

$(".carousel.carousel-slider").carousel({
  fullWidth: true,
  height: 800,
});

$("#carousel-game-home").carousel({
  onCycleTo: function (event) {
    var index = $(event).index() + 1;

    $(".active").removeClass("active");

    $("#content-title-" + index).addClass("active");

    $(".active-detail").removeClass("active-detail").addClass("hide");

    $("#content-detail-" + index)
      .removeClass("hide")
      .addClass("active-detail");
  },
});

$("#carousel-game-home .next").click(function (e) {
  e.preventDefault();
  e.stopPropagation();
  $("#carousel-game-home").carousel("next");
});

$("#carousel-exmplore .next").click(function (e) {
  e.preventDefault();
  e.stopPropagation();
  $("#carousel-exmplore").carousel("next");
});

$("#carousel-game-home .prev").click(function (e) {
  e.preventDefault();
  e.stopPropagation();
  $("#carousel-game-home").carousel("prev");
});

$("#carousel-exmplore .prev").click(function (e) {
  e.preventDefault();
  e.stopPropagation();
  $("#carousel-exmplore").carousel("prev");
});

$(".name span").click(function (e) {
  e.preventDefault();
  e.stopPropagation();

  $(".title").removeClass("active");
  $(this).toggleClass("active");

  var elem = document.querySelector("#carousel-game-home");

  var instance = M.Carousel.getInstance(elem);

  var index = $(this).data("index");

  instance.set(index - 1);
});

function checkWidth() {
  var $window = $(window);

  var windowsize = $window.width();

  if (windowsize <= 600) {
    $("#links").addClass("hide");
  }
}

checkWidth();

$(".menu-open").click(function (e) {
  $("#links").toggleClass("hide");
});

$(".owl-carousel-banner").owlCarousel({
  items: 3,
  margin: 30,
  loop: true,
  autoplay:true,
  autoplayTimeout:10000,
  autoHeight: true,
  responsiveClass: true,
  responsive: {
    0: {
      items: 1,
      nav: false,
      dots: true,
    },
    600: {
      items: 1,
      nav: false,
      dots: false,
    },
    768: {
      items: 1,
      nav: false,
      dots: true,
    },
    1000: {
      items: 1,
      nav: false,
      dots: true,
    },
  },
  nav: false,
  dots: true,
});

$(".owl-client").owlCarousel({
  items: 4,
  margin: 20,
  autoHeight: true,
  responsiveClass: true,
  nav: false,
  dots: false,
});

$(window).scroll(function () {
  var scroll = $(window).scrollTop();

  if (scroll >= 500) {
    $("#navbar").addClass("fixed");
  } else {
    $("#navbar").removeClass("fixed");
  }
});
